<svelte:options runes={true} />

<script lang="ts">
	import Player from "@vimeo/player";
	import { createEventDispatcher, onMount } from "svelte";

	interface PlayerProps {
		src: string;
		autoplay?: boolean;
		style?: string;
	}

	const dispatch = createEventDispatcher();
	let { src, autoplay = false, style }: PlayerProps = $props();

	let playerElement: HTMLIFrameElement | null = null;
	let videoUrl = $derived(`https://player.vimeo.com/video/${src}${src.includes("?") ? "&" : "?"}autoplay=${autoplay ? 1 : 0}&muted=0&title=0&byline=0&portrait=0`);

	onMount(() => {
		if (!playerElement) return;

		const player = new Player(playerElement);

		player.on("ended", () => {
			dispatch("ended");
		});

		return () => {
			player.destroy();
		};
	});
</script>

<div class="aspect-video w-full">
	<iframe {style} bind:this={playerElement} src={videoUrl} title="Vimeo video player" class="h-full w-full" frameborder="0" allow="autoplay; fullscreen" allowfullscreen> </iframe>
</div>
